import React, { memo, useMemo } from 'react';

// styles
import {
  SearchContainer,
  PlaceHolderContainer,
  PlaceHolder1,
  PlaceHolder2,
  SearchButton,
} from './style';

// icons
import { useStoreIcon, IconName } from 'shared/icons';

// hooks
import { useRemoteConfig } from 'shared/store/remoteConfigs/hooks';
import { useKeyboardClick } from 'shared/hooks/useKeyboardClick';

// constants
import { ARIA_LABELS } from 'shared/components/Header/MobileHeader/constants';
const SEARCH_ICON_SIZE = '20px';

const EMPTY_FUNC = () => {
  /** DO NOTHING */
};

interface ISearchbarProps {
  onClick: VoidFunction;
  tabIndex: -1 | 0;
}

const Searchbar = ({ onClick = EMPTY_FUNC }: ISearchbarProps) => {
  const { placeHolderText1, placeHolderText2 } = useRemoteConfig('pdpSearchbar');
  const SearchIcon = useStoreIcon(IconName.SEARCH);
  const keyboardProps = useKeyboardClick(onClick);

  const randomIndex = useMemo(
    () => Math.floor(Math.random() * placeHolderText2.length),
    [placeHolderText2.length]
  );

  return (
    <SearchContainer
      {...keyboardProps}
      aria-label={ARIA_LABELS.SEARCH_PRODUCTS}
      data-at="search-btn"
    >
      <PlaceHolderContainer>
        <PlaceHolder1>{placeHolderText1}</PlaceHolder1>
        <PlaceHolder2>{placeHolderText2[randomIndex]}</PlaceHolder2>
      </PlaceHolderContainer>
      <SearchButton>
        <SearchIcon size={SEARCH_ICON_SIZE} aria-hidden="true" />
      </SearchButton>
    </SearchContainer>
  );
};

export default memo(Searchbar);
